import { getAvailableGiftItems } from "./getAvailableGiftItems.js";
const toBookItem = (item) => ({
    sku: item.sku,
    isbnean: item.isbnean,
    name: item.name,
    image: item.image,
    shapeIdentifier: item.shapeIdentifier,
    canBeVisible: true,
});
const getGiftItems = (giftConfig, selectedGiftSkus) => {
    const availableGiftItems = getAvailableGiftItems(giftConfig);
    if (availableGiftItems.length === 0) {
        return [];
    }
    const selectedSkus = new Set((selectedGiftSkus ?? []).filter(Boolean));
    if (selectedSkus.size === 0) {
        return availableGiftItems.map(toBookItem);
    }
    const selectedGiftItems = availableGiftItems.filter((item) => selectedSkus.has(item.sku));
    return selectedGiftItems.map(toBookItem);
};
export const getBookClubDisplayProducts = ({ isBookClub, shouldDisplayGifts, selectedGiftSkus, giftConfig, dispatchProducts, }) => {
    if (!isBookClub) {
        return dispatchProducts;
    }
    if (shouldDisplayGifts) {
        return getGiftItems(giftConfig, selectedGiftSkus);
    }
    return dispatchProducts;
};
